import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import { otherLang, setLanguage, type Lang } from '@/lib/i18n';
import { cn } from '@/lib/utils';

/** Compact language pill — single-tap switches between AR ↔ EN. */
export function LanguageToggle({
  className,
  variant = 'outline',
}: {
  className?: string;
  /** `outline` = on light surfaces, `ghost` = on plum/gradient surfaces. */
  variant?: 'outline' | 'ghost';
}) {
  const { t, i18n } = useTranslation('common');
  const current = ((i18n.language?.split('-')[0] === 'en' ? 'en' : 'ar') as Lang);
  const next = otherLang(current);

  return (
    <button
      type="button"
      onClick={() => setLanguage(next)}
      className={cn(
        'inline-flex h-9 items-center justify-center gap-1.5 rounded-full px-3.5 text-sm font-medium transition active:scale-[0.98]',
        variant === 'outline'
          ? 'border border-border bg-card text-foreground hover:bg-brand-wash'
          : 'border border-white/30 bg-white/10 text-white backdrop-blur hover:bg-white/20',
        className,
      )}
      aria-label={t(`nav.switchTo${next === 'ar' ? 'Arabic' : 'English'}` as const)}
    >
      <Globe className="h-3.5 w-3.5 opacity-80" aria-hidden />
      <span>{next === 'ar' ? 'العربية' : 'English'}</span>
    </button>
  );
}
